











































































import { Component, namespace, mixins } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { NEWS_API } from '~/assets/config/api-path'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { filterDate } from '~/assets/filters/date'
import { IMeta } from '~/assets/interfaces/meta'
import MixinGeneral from '~/assets/mixins/general'
import { IContent } from '~/assets/interfaces/content'
import { filterUrl } from '~/assets/filters/url'
import ComponentImage from '~/components/images/image.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentProductAdditionalWrapper from '~/components/products/product-additional-wrapper.vue'

const pageStore = namespace('page')
const siteStore = namespace('site')
@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    LazyHydrate,
    ComponentNavigationBreadcrumbs,
    ComponentPageContent,
    ComponentTypographyH1,
    ComponentProductAdditionalWrapper,
    ComponentImage,
  },
  filters: {
    filterDate,
    filterUrl,
  },
})
export default class pageContactsIndex extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
    route,
    error,
    redirect,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
    redirect: any
  }) {
    try {
      const response = await $axios.$get(
        NEWS_API + '/' + route.params._id + '/'
      )

      // Статья открыта по номеру, а основной адрес у неё — по символьному коду
      if (response && response.redirect) {
        return redirect(301, response.redirect, route.query)
      }

      return response
    } catch (err) {
      error({ statusCode: 404, message: 'Post not found' })
    }
  }

  private dateModified: string = ''
  private datePublished: string = ''
  private image: string[] = []
  private date: string = ''

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []
  private productsAdditionalId: number | null = null
  private content: IContent[] = []
  private viewDetailPicture: string = ''
  private detailPicture: string = ''
  // Размеры исходника картинки из API: место под неё резервируется до
  // загрузки, текст вокруг не перестраивается (CLS)
  private detailPictureSize: { width: number; height: number } | null = null

  private created() {
    if (this.meta) {
      this.setMeta(this.meta)
    }
    if (this.breadcrumbs) {
      this.setBreadcrumbs(this.breadcrumbs)
    }
  }

  @siteStore.State('origin') private origin!: string

  private get structuredData() {
    const url =
      (this.meta && this.meta.canonical) || this.origin + this.$route.path
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      url,
      mainEntityOfPage: url,
      dateModified: new Date(this.dateModified).toISOString(),
      datePublished: new Date(this.datePublished).toISOString(),
      headline: this.meta ? this.meta.h1 : '',
      image: this.image,
    }
  }

  private head() {
    return {
      script: [
        {
          // hid: без него vue-meta дописывает на клиенте копию блока
          hid: 'ld-news-article',
          json: this.structuredData,
          type: 'application/ld+json',
        },
      ],
    }
  }

  private get classContentImage() {
    return {
      [this.$style.contentImage]: true,
      [this.$style.left]: this.viewDetailPicture === 'left',
      [this.$style.right]: this.viewDetailPicture === 'right',
      [this.$style.width]:
        !this.viewDetailPicture || this.viewDetailPicture === 'width',
      [this.$style.desktop]: this.$device.isDesktop,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }
}
